// 用于全局存储一些常用的公共数据，如用户名，用户id，开发者中心开光状态，存在sessionStorage中容易被用户手动修改，所以暂存在这里
// 需要存session的可以在这里加，在要使用的地方引入
import axios from '@/plugins/axios'
import CookieOperation from '@/plugins/cookie'

const applicationSettings = new Proxy({}, {
  get (target, p, receiver) {
    // 获取值的时候如果没有就去请求，并返回一个空值，所以第一次需要一个不存在的值的时候不能依赖这里
    if (!Reflect.has(target, p)) {
      getApplicationSettings(p)
      return ''
    }
    return Reflect.get(target, p)
  }
})

/**
 * @param {string} key 需要的对象的key
 * */
async function getApplicationSettings (key) {
  // 初始化没有要获取的值的时候默认获取以下几项 waterMarkEnable:水印开启状态
  let defaultKeys = []
  if (!key) {
    defaultKeys = ['waterMarkEnable']
  }
  let domain = document.domain
  if (domain === 'localhost') {
    domain = CookieOperation.get('domain') || console.warn('本地开发设置 cookie.domain') || '8854.rc-dev-test.ywsoftware.cn'
  }
  let params = { 'domain': domain }
  /** 注意：1.平台这边和开发者中心不同，平台无法访问开发者中心的服务，应用设置会在另一个接口返回 ；
   * 2.当前该接口为白名单，所以可以直接作为插件在初始化的时候请求，要注意后续后端的变更
   * */
  axios.get('/system-api/application/getSettingByDomain', { params }).then(res => {
    if (res.data.data) {
      // 取过一次的值全局保存不需要再次请求
      if (key) {
        applicationSettings[key] = res.data.data[key]
      } else {
        defaultKeys.forEach(item => {
          applicationSettings[item] = res.data.data[item]
        })
      }
    }
  })
}

export { applicationSettings, getApplicationSettings }



// WEBPACK FOOTER //
// ./src/store/app-common-data/applicationSetting.js